import { compose, pick } from 'ramda';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setDefaultTranslationsAction } from 'js/hooks/i18n/store/actions';

import LimitEditDisplay from './LimitEditDisplay';
import LimitEditEditor from './LimitEditEditor';
import { Control } from '../Control';
import withField from '../withField';
import translations from './translations';
import { useProductLimitsTranslate } from './helpers';

import style from './index.scss';

/**
 * This control requires React Final Form to work (taken from `common/Form`)
 *
 * Current limit is taken from `initialValues` and is handled by RFF. So, to change it - you need to pass new
 * `initialValues` to form (or to control itself).
 *
 * Changes from "Edit" mode are passed up to form state and must be manually reset from within form if you intend to
 * "cancel" edit.
 */
export const LimitEdit = ({
    name,
    className = '',
    tKeyPrefix = 'playtech.mobile.system.limitEdit.',

    edit = false,

    unlimitedValue = '92233720368547758.07',

    ...props
}) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setDefaultTranslationsAction(translations));
    }, [dispatch]);
    const tt = useProductLimitsTranslate(tKeyPrefix);
    const { meta } = props;

    const commonProps = {
        tt,
        unlimitedValue
    };
    const classForEditMode = edit ? style.editMode : '';

    return (
        <Control
            {...{ meta }}
            className={`${className} ${classForEditMode}`}
            classNames={pick(['content'], style)}
        >
            {!edit
                ? <LimitEditDisplay {...{ ...props, ...commonProps }} />
                : <LimitEditEditor { ...{ ...props, ...commonProps }} />}
        </Control>
    );
};

export default compose(
    withField
)(LimitEdit);
